const state = {
    paymentSettingsRes:null,
  
    selectedPaymentReq: null,
    selectedPaymentRes:null,

    selectedPayTypeObj:null,
    
    createBookingReq: null,
    createBookingRes: null,

    orderDetailRes:null,
    orderDetSignedInRes:null
};

const getters = {
    GET_PAY_SETTINGS_RES: (state) => {
        return state.paymentSettingsRes;
    },

    GET_SEL_PAY_REQ: (state) => {
        return state.selectedPaymentReq;
    },
    GET_SEL_PAY_RES: (state) => {
        return state.selectedPaymentRes;
    },
    GET_SEL_PAY_TYPE_OBJ: (state) => {
        return state.selectedPayTypeObj;
    },

    GET_CREATE_BOOKING_REQ: (state) => {
        return state.createBookingReq;
    },
    GET_CREATE_BOOKING_RES: (state) => {
        return state.createBookingRes;
    },
    GET_ORDER_DETAIL_RES: (state) => {
        return state.orderDetailRes;
    },
    GET_ORDER_DETAIL_SIGNEDIN_RES: (state) => {
        return state.orderDetSignedInRes;
    },
    


};


const actions = {

    CLEAR_PAYMENT_STORE: ({ commit }) => {
        commit('clearPaymentStore');
    },

    
   
    SET_SEL_PAY_REQ: ({ commit }, selPayReq) => {

        commit('saveSelPaymentReq', selPayReq);

    },
    SET_SEL_PAY_RES: ({ commit }, selPayRes) => {

        commit('saveSelPaymentRes', selPayRes);

    },
    SET_PAY_SETTINGS_RES: ({ commit }, paySettRes) => {

        commit('savePaySettingsRes', paySettRes);

    },
    SET_PAY_TYPE_OBJ: ({ commit }, payTypeObj) => {

        commit('saveSelPayTypeObj', payTypeObj);

    },

    SET_CREATE_BOOKING_REQ: ({ commit }, req) => {
        commit('saveCreateBookingReq', req)
    },
    SET_CREATE_BOOKING_RES: ({ commit }, res) => {
        commit('saveCreateBookingRes', res)
    },
    SET_ORDER_DETAIL_RES:  ({ commit }, res) => {
        commit('saveOrderDetailRes', res)
    },

    SET_ORDER_DETAIL_SIGNEDIN_RES:  ({ commit }, res) => {
        commit('saveOrderDetSignedInRes', res)
    },

    

};


const mutations = {
    clearPaymentStore: (state) => {
     
        state.selectedPaymentReq = null;
        state.selectedPaymentRes = null;
        state.paymentSettingsRes=null;
        state.selectedPayTypeObj=null;

        state.createBookingReq = null;
        state.createBookingRes = null;

        state.orderDetailRes = null;
        state.orderDetSignedInRes = null;
    },
   
    saveSelPaymentReq: (state, selPayReq) => {
        state.selectedPaymentReq = selPayReq;
    },
    saveSelPaymentRes: (state, selPayRes) => {
        state.selectedPaymentRes = selPayRes;
    },
    savePaySettingsRes: (state, paySettRes) => {
        state.paymentSettingsRes = paySettRes;
    },
    saveSelPayTypeObj: (state, payTypeObj) => {
        state.selectedPayTypeObj = payTypeObj;
    },

    saveCreateBookingReq: (state, req) => {
        state.createBookingReq = req;
    },
    saveCreateBookingRes: (state, res) => {
        state.createBookingRes = res;
    },

    saveOrderDetailRes: (state, res) => {
        state.orderDetailRes = res;
    },

    saveOrderDetSignedInRes: (state, res) => {
        state.orderDetSignedInRes = res;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}